import React, { useContext} from "react";
import { useEffect } from "react";
import Application from "../../components/application";
import Button from "@mui/material/Button";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { useNavigate } from "react-router-dom";

import {Tooltip} from "@mui/material";
import useTemplateState from "../../hooks/useTemplate";
import { AuthContext } from "../../contexts/auth";
import TELAS from "../../constants/telas";
import TELA_ACOES from "../../constants/telaAcoes";
import permissaoTelas from "../../utils/permissaoTelas";
import PaginationGridView from "../../components/views/paginationGridView";

const PAGINA = {
    aplicacao: 'SisPalo - Tarefas',
    funcionalidade: 'Tarefas',
    tela: TELAS.TEMPLATE_TAREFAS,
    acoes: [TELA_ACOES.Incluir, TELA_ACOES.Alterar, TELA_ACOES.Apagar, TELA_ACOES.Consultar]
}

const TemplateTarefas = () => {

    const states = useTemplateState()
    const {permissaoUsuario, user} = useContext(AuthContext);
    const navigate = useNavigate()

    /* permissão para telas*/
    useEffect(() => {
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)) {
            if (states.pesquisa.value === '') {
                states.submit.set();
            }
        }
        else {
            navigate('/gestor/dashboard');
            return;
        }
        
    }, [permissaoUsuario, states.pesquisa.value]);

    const columns = [
        {field:'id', headerName:'ID', width: 80},
        {field:'name', headerName:'Nome Template', flex: 1},
        {field:'ativo', headerName:'Ativo', width: 50, renderCell: (cellValues) =>{
            return (
                <Tooltip title="Ativo" placement="bottom" arrow>
                        {
                            cellValues.row.ativo ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                        }
                </Tooltip>                
                )
            }
        },
        {field:'editavel', headerName:'Editável', width: 100, renderCell: (cellValues) =>{
            return (
                <Tooltip title="é editável" placement="bottom" arrow>
                        {
                            cellValues.row.editavel ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                        }
                </Tooltip>                
                )
            }
        },
        {field:'tem_formulario', headerName:'', width: 50, renderCell: (cellValues) =>{
            return (
                <Tooltip title="Tem Formulário" placement="bottom" arrow>
                        {
                            cellValues.row.tem_formulario ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                        }
                </Tooltip>                
                )
            }
        },

        {field:'data_criacao', headerName:'Data Criação', width: 150},
        {field:'', headerName:'Ações', width:110, renderCell: (cellValues) =>{
            return (
                <>
                    <Tooltip title="Configurar Permições" placement="bottom" arrow>
                        <Button disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)} 
                        onClick={()=>navigate(`/gestor/template/${cellValues.row.id}/permissao`)} sx={{width:'55px', padding: 0,minWidth:0}}><SettingsApplicationsIcon /></Button>
                    </Tooltip>
                    <Tooltip title="Apagar" placement="bottom" arrow>
                        <Button color='error' disabled={ 
                            !permissaoTelas(permissaoUsuario, TELA_ACOES.Apagar, PAGINA)  || cellValues.row.numero_secoes > 0} 
                            onClick={()=>{states.itemDelete.set(cellValues.row);states.openDialog.set(true)}
                                    } 
                            sx={{width:'55px', padding: 0,minWidth:0}}> <DeleteIcon /></Button>
                    </Tooltip>
                    <Tooltip title="Editar" placement="bottom" arrow>
                        <Button 
                            disabled={
                                !(user.value.is_staff || 
                                    (!user.value.is_staff && 
                                        cellValues.row.editavel && 
                                        permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)
                                    )
                                )
                            }
                            onClick={() => navigate(`/gestor/template/formulario/${cellValues.row.id}`)} 
                            sx={{ width: '55px', padding: 0, minWidth: 0 }}
                            >
                            <EditIcon />
                        </Button>
                    </Tooltip>
                </>
                
            )
        }}
    ]
   
    return (
   
        <Application>
            <>
                <PaginationGridView 
                    title='Template Tarefas' 
                    states={states}
                    rows={states.template.value}
                    columns={columns}
                    urlAdd={permissaoTelas(permissaoUsuario,TELA_ACOES.Incluir,PAGINA) ? `/gestor/template/formulario` : null}
                    urlVoltar={'/gestor/dashboard'}                    
                    onClickPesquisa={() => {
                        states.pagination.setPage(0);
                        states.submit.set(1); 
                    }}
                    nomeItem='Template Terafa'
                    modalAdd={null}
                    children={null}
                />
            </>
        </Application>
   
    )
}

export default TemplateTarefas;